import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BaseAppState } from '../../../core/store/reducers';
import { combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthSelectors } from '../selectors/auth.selectors';
import { MAIN_NAVIGATION_PATHS } from '../../../core/router/definitions/main-navigation.definitions';

@Injectable()
export class DashboardGuardService implements CanActivate {
  isAdmin$ = this.store.pipe(select(AuthSelectors.getIsAdmin));
  isDeveloper$ = this.store.pipe(select(AuthSelectors.getIsDeveloper));

  constructor(private router: Router, private store: Store<BaseAppState>) {
  }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<UrlTree | boolean> {
    return combineLatest([this.isAdmin$, this.isDeveloper$]).pipe(
      take(1),
      map(([isAdmin, isDeveloper]) => {
        let redirectUrlTree: UrlTree;
        if (isAdmin) {
          redirectUrlTree = this.router.createUrlTree([MAIN_NAVIGATION_PATHS.admin]);
          return redirectUrlTree;
        } else if (isDeveloper) {
          redirectUrlTree = this.router.createUrlTree([MAIN_NAVIGATION_PATHS.develop]);
          return redirectUrlTree;
        }

        return true;
      })
    );
  }
}